'use strict';

function dropdownContentDirective () {

  function link (scope, el, attr, ctrl) {
    scope.ctrl = ctrl;

    el.on('click', function (e) {
      // close dropdown list on item click to prevent the list from flashing during certain transitions
      // NOTE: This was disabled since is not the desired behavior, removing it
      // solved [CORE-908] but will probably give back a regression of an issue
      // where edit dropdown on annotations was flashing. Needs to be tested.
      // scope.ctrl.show = false;

      // stop event from propogating up to window.document because we have a listener attached
      // to the document that will close all the open dropdowns
      e.stopPropagation();
    });
  }

  return {
    link: link,
    require: '^sbDropdown',
    template: '<div class="dropdown-content" ng-show="ctrl.show" ng-transclude></div>',
    transclude: true
  };
}

module.exports = dropdownContentDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dropdown/src/dropdownContent/DropdownContentDirective.js